module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_08.dot-a94d5e6a24d620014a1c5f7c274532f9.svg";